(() => {
  if (window.__nbWave2Sticky) return;
  window.__nbWave2Sticky = true;

  function firstInvalid() {
    const box = document.getElementById('nbProductSellBox');
    if (!box) return null;
    const fields = [...box.querySelectorAll('.nb-field[required]')];
    for (const f of fields) {
      if (!String(f.value || '').trim()) return f;
    }
    const age = document.getElementById('nbAge18Confirm');
    if (age && !age.checked) return age;
    return null;
  }

  function syncSticky() {
    const price = window.__nbWave2LastPrice || '';
    const variant = window.__nbWave2LastVariant || '';
    const stickyMeta = document.querySelector('#nbStickyAtc [data-nb-sticky-price]');
    const stickyVar = document.querySelector('#nbStickyAtc [data-nb-sticky-variant]');
    if (stickyMeta && price) stickyMeta.textContent = price;
    if (stickyVar && variant) stickyVar.textContent = variant;
  }

  function setupSticky() {
    const bar = document.getElementById('nbStickyAtc');
    const btn = document.getElementById('nbStickyAtcBtn');
    if (!bar || !btn) return;
    if (btn.dataset.nbStickyBound === '1') return;
    btn.dataset.nbStickyBound = '1';
    const mq = window.matchMedia('(max-width: 749px)');
    let submitting = false;
    function updateVis() {
      const show = mq.matches;
      bar.classList.toggle('is-visible', show);
      document.body.classList.toggle('nb-sticky-atc-active', show);
      syncSticky();
      const pending = !!firstInvalid();
      btn.disabled = submitting;
      btn.setAttribute('aria-disabled', pending || submitting ? 'true' : 'false');
      const ready = document.querySelector('button.product-form__submit');
      const label = ready ? (ready.textContent || '').replace(/\s+/g, ' ').trim() : '';
      if (label && !submitting) btn.textContent = label;
    }
    btn.addEventListener('click', function (e) {
      e.preventDefault();
      if (submitting) return;
      const invalid = firstInvalid();
      if (invalid) {
        invalid.scrollIntoView({ behavior: 'smooth', block: 'center' });
        try { invalid.focus({ preventScroll: true }); } catch (_) { try { invalid.focus(); } catch (__) {} }
        return;
      }
      const submit = document.querySelector('form[action*="/cart/add"] button.product-form__submit, form[action*="/cart/add"] button[name="add"]');
      if (submit && !submit.disabled) {
        submitting = true;
        btn.disabled = true;
        submit.click();
        setTimeout(function () { submitting = false; updateVis(); }, 2500);
      }
    });
    document.addEventListener('change', updateVis, true);
    document.addEventListener('input', updateVis, true);
    mq.addEventListener('change', updateVis);
    updateVis();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', setupSticky);
  else setupSticky();
})();
